/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdaysat3Inputs */

const en_placewebdaysat3 = /** @type {(inputs: Placewebdaysat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sat`)
};

const de_placewebdaysat3 = /** @type {(inputs: Placewebdaysat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sa`)
};

/**
* | output |
* | --- |
* | "Sat" |
*
* @param {Placewebdaysat3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdaysat3 = /** @type {((inputs?: Placewebdaysat3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdaysat3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdaysat3(inputs)
	return de_placewebdaysat3(inputs)
});
export { placewebdaysat3 as "placeWebDaySat" }